import { FC, ReactNode } from 'react';
import { cn, CourseImage } from '@fe-learner-common';
import { useAdjustTextContrast } from '@fe-learner-common/hooks/useAdjustTextContrast';
type HeroContainerProps = {
  children: ReactNode;
  topSlot?: ReactNode;
  background: {
    image?: string | null;
    backdrop?: string | null;
    color?: string | null;
  };
  courseImage?: string | null;
  courseImageAlt: string;
};

const getBackgroundStyle = (background: HeroContainerProps['background']) => {
  switch (true) {
    case !!background.color:
      return {
        containerClasses: ``,
        containerStyle: { backgroundColor: background.color },
        contentClasses: '',
      };
    case !!background.image:
      return {
        containerClasses: '',
        containerStyle: {
          backgroundImage: `url(${background.image})`,
        },
        contentClasses: '',
      };
    case !!background.backdrop:
      return {
        containerClasses: 'lf:bg-neutral-500 lf:backdrop-blur-[57px]',
        containerStyle: {
          background: `url(${background.backdrop}) #CDCDCD`,
        },
        contentClasses: 'lf:bg-neutral-0/[.88] lf:backdrop-blur-[200px]',
      };
  }
};

export const HeroContainer: FC<HeroContainerProps> = ({
  children,
  topSlot,
  background,
  courseImage,
  courseImageAlt,
}) => {
  const containerRef = useAdjustTextContrast();
  const styles = getBackgroundStyle(background);
  return (
    <div
      ref={containerRef}
      className={cn(
        'lf:relative lf:flex lf:items-center lf:justify-center lf:bg-neutral-300 lf:bg-cover lf:bg-no-repeat ',
        styles?.containerClasses,
      )}
      style={styles?.containerStyle}
    >
      <div className={cn('lf:flex lf:flex-1 ', styles?.contentClasses)}>
        <div className="lf:l-page lf:2xl:container">
          <div
            className="lf:flex-1 lf:px-3 lf:pb-6 lf:[&_*]:!text-inherit"
            style={{ color: `red !important ` }}
          >
            {topSlot}
          </div>
          <div className="lf:flex lf:flex-col lf:gap-8 lf:lg:flex-row lf:lg:gap-16">
            <CourseImage
              className={cn(
                'lf:aspect-video lf:w-full lf:self-start lf:lg:mx-3 lf:lg:max-w-[320px]',
              )}
              thumbnail={courseImage}
              alt={courseImageAlt}
            />

            <div className="lf:flex lf:flex-1 lf:flex-col lf:gap-6 lf:lg:px-4">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
